<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter 
                    :headers="headers" 
                    :viewName="viewName" 
                    :classicSearch="false"
                    :classicColumns="['Username', 'ProductInfo', 'HsCode', 'ProductNameVN', 'Description', 'InvoicePrice']"
                    v-on:applyFilter="applyFilter" 
                    v-on:quickFilter="quickFilter">
                </hpo-filter>
                <!-- Thông tin đã chọn và actions -->
                <v-card-text v-if="selectedItems.length > 0" class="py-2">
                    <v-row align="center">
                        <v-col cols="auto">
                            <v-chip color="primary" outlined>
                                <v-icon left small>mdi-check-circle</v-icon>
                                Đã chọn {{ selectedItems.length }} khai báo
                            </v-chip>
                            <v-chip color="success" outlined class="ml-2" v-if="selectedTotalAmount > 0">
                                <v-icon left small>mdi-currency-usd</v-icon>
                                Tổng: {{ formatCurrency(selectedTotalAmount) }} VND
                            </v-chip>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn 
                                color="primary" 
                                text 
                                small 
                                @click="selectAll"
                                v-if="selectedItems.length < items.length"
                            >
                                <v-icon left small>mdi-checkbox-marked-circle</v-icon>
                                Chọn tất cả
                            </v-btn>
                            <v-btn 
                                color="grey" 
                                text 
                                small 
                                @click="clearSelection"
                                v-else
                            >
                                <v-icon left small>mdi-checkbox-blank-circle-outline</v-icon>
                                Bỏ chọn tất cả
                            </v-btn>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="auto">
                            <v-btn 
                                color="error"
                                @click="deleteSelectedQuotes"
                                :disabled="selectedItems.length === 0"
                                class="mr-2"
                            >
                                <v-icon left>mdi-delete</v-icon>
                                Xóa tất cả
                            </v-btn>
                            <v-btn 
                                color="success" 
                                @click="exportData"
                            >
                                <v-icon left>mdi-file-excel</v-icon>
                                Xuất Excel ({{ selectedItems.length }} mục)
                            </v-btn>
                        </v-col>

                    </v-row>
                </v-card-text>
                
                <v-data-table 
                    :headers="headers" 
                    :items="items" 
                    :options.sync="pagination" 
                    :server-items-length="total_rows" 
                    :footer-props="items_per_page" 
                    :must-sort="true" 
                    :loading="loading" 
                    :mobile-breakpoint="100"
                    item-key="ID"
                    show-select
                    v-model="selectedItems"
                    dense
                    fixed-header
                    height="calc(100vh - 300px)"
                    class="fixed-columns-table">
                    
                    <!-- Mã KH -->
                    <template slot="item.Username" slot-scope="{ item }">
                        <v-edit-dialog
                            :return-value.sync="item.UID"
                            large
                            @save="saveField(item, 'UID', item.UID)">
                            <div>{{ item.Username || '-' }}</div>
                            <template v-slot:input>
                                <v-autocomplete
                                    v-model="item.UID"
                                    :items="customers"
                                    item-text="Username"
                                    item-value="ID"
                                    label="Chọn khách hàng"
                                    dense
                                    clearable
                                ></v-autocomplete>
                            </template>
                        </v-edit-dialog>
                    </template>

                    <!-- Tên loại hàng -->
                    <template slot="item.ProductInfo" slot-scope="{ item }">
                        <v-edit-dialog
                            style="min-width:250px;max-width:300px;"
                            :return-value.sync="item.ProductInfo"
                            large
                            @save="saveField(item, 'ProductInfo', item.ProductInfo)">
                            <div>{{ item.ProductInfo || '-' }}</div>
                            <template v-slot:input>
                                <v-textarea
                                    v-model="item.ProductInfo"
                                    label="Tên loại hàng"
                                    rows="8"
                                    single-line
                                ></v-textarea>
                            </template>
                        </v-edit-dialog>
                    </template>

                    <!-- HSCODE -->
                    <template slot="item.HsCode" slot-scope="{ item }">
                        <v-edit-dialog
                            :return-value.sync="item.HsCode"
                            large
                            @save="saveField(item, 'HsCode', item.HsCode)">
                            <div>{{ item.HsCode || '-' }}</div>
                            <template v-slot:input>
                                <v-text-field
                                    v-model="item.HsCode"
                                    label="HSCODE"
                                    single-line
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </template>

                    <!-- Tên hàng TV -->
                    <template slot="item.ProductNameVN" slot-scope="{ item }">
                        <v-edit-dialog
                            :return-value.sync="item.ProductNameVN"
                            large
                            @save="saveField(item, 'ProductNameVN', item.ProductNameVN)">
                            <div>{{ item.ProductNameVN || '-' }}</div>
                            <template v-slot:input>
                                <v-text-field
                                    v-model="item.ProductNameVN"
                                    label="Tên hàng tiếng Việt"
                                    single-line
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </template>

                    <!-- Mô tả sản phẩm (Nhãn hiệu, chất liệu, công suất, kích thước) -->
                    <template slot="item.Description" slot-scope="{ item }">
                        <v-edit-dialog
                            style="min-width:250px;max-width:350px;"
                            :return-value.sync="item.Description"
                            large
                            @save="saveField(item, 'Description', item.Description)">
                            <div>{{ item.Description || '-' }}</div>
                            <template v-slot:input>
                                <v-textarea
                                    v-model="item.Description"
                                    label="Mô tả sản phẩm (Nhãn hiệu, chất liệu, công suất, kích thước)"
                                    single-line
                                    rows="6"
                                ></v-textarea>
                            </template>
                        </v-edit-dialog>
                    </template>
                    
                    <!-- Hình ảnh -->
                    <template slot="item.ImageUrl" slot-scope="{ item }">
                        <div class="d-flex align-center">
                            <v-img 
                                v-if="item.ImageUrl" 
                                :src="image_proxy + encodeURIComponent(item.ImageUrl) + '&w=50&h=50'" 
                                max-height="50" 
                                max-width="50"
                                class="ma-1 cursor-pointer"
                                @click="viewImage(item.ImageUrl)">
                            </v-img>
                            <span v-else class="grey--text text--lighten-1">-</span>
                            <v-btn 
                                x-small 
                                icon 
                                color="primary" 
                                @click="openImageUpload(item)"
                                class="ml-1">
                                <v-icon x-small>mdi-upload</v-icon>
                            </v-btn>
                        </div>
                    </template>

                    <!-- Thuế NK % -->
                    <template slot="item.ImportTax" slot-scope="{ item }">
                        <v-edit-dialog
                            :return-value.sync="item.ImportTax"
                            large
                            @save="saveField(item, 'ImportTax', item.ImportTax)">
                            <div>{{ item.ImportTax || 0 }}%</div>
                            <template v-slot:input>
                                <v-text-field
                                    v-model="item.ImportTax"
                                    label="Thuế NK (%)"
                                    type="number"
                                    single-line
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </template>

                    <!-- Giá xuất HĐ -->
                    <template slot="item.InvoicePrice" slot-scope="{ item }">
                        <v-edit-dialog
                            :return-value.sync="item.InvoicePrice"
                            large
                            @save="saveField(item, 'InvoicePrice', item.InvoicePrice)">
                            <div>{{ formatCurrency(item.InvoicePrice) }}</div>
                            <template v-slot:input>
                                <v-text-field
                                    v-model="item.InvoicePrice"
                                    label="Giá xuất HĐ"
                                    type="number"
                                    single-line
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </template>

                    <!-- Đơn vị tiền tệ -->
                    <template slot="item.Currency" slot-scope="{ item }">
                        <v-edit-dialog
                            :return-value.sync="item.Currency"
                            large
                            @save="saveField(item, 'Currency', item.Currency)">
                            <div>{{ item.Currency || 'VND' }}</div>
                            <template v-slot:input>
                                <v-select
                                    v-model="item.Currency"
                                    :items="['VND', 'USD', 'CNY', 'EUR']"
                                    label="Đơn vị tiền tệ"
                                    single-line
                                ></v-select>
                            </template>
                        </v-edit-dialog>
                    </template>

                    <!-- Giá khai báo -->
                    <template slot="item.CustomsPriceVND" slot-scope="{ item }">
                        <v-edit-dialog
                            :return-value.sync="item.CustomsPriceVND"
                            large
                            @save="saveField(item, 'CustomsPriceVND', item.CustomsPriceVND)">
                            <div>{{ formatCurrency(item.CustomsPriceVND) }}</div>
                            <template v-slot:input>
                                <v-text-field
                                    v-model="item.CustomsPriceVND"
                                    label="Giá khai báo"
                                    type="number"
                                    single-line
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </template>

                    <!-- Thuế VAT -->
                    <template slot="item.VatTax" slot-scope="{ item }">
                        <v-edit-dialog
                            :return-value.sync="item.VatTax"
                            large
                            @save="saveField(item, 'VatTax', item.VatTax)">
                            <div>{{ formatCurrency(item.VatTax) }}</div>
                            <template v-slot:input>
                                <v-text-field
                                    v-model="item.VatTax"
                                    label="Thuế VAT"
                                    type="number"
                                    single-line
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </template>

                    <!-- Phí DV -->
                    <template slot="item.ServiceFee" slot-scope="{ item }">
                        <v-edit-dialog
                            :return-value.sync="item.ServiceFee"
                            large
                            @save="saveField(item, 'ServiceFee', item.ServiceFee)">
                            <div>{{ formatCurrency(item.ServiceFee) }}</div>
                            <template v-slot:input>
                                <v-text-field
                                    v-model="item.ServiceFee"
                                    label="Phí dịch vụ"
                                    type="number"
                                    single-line
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </template>

                    <!-- Số kiện -->
                    <template slot="item.NumberOfPack" slot-scope="{ item }">
                        <v-edit-dialog
                            :return-value.sync="item.NumberOfPack"
                            large
                            @save="saveField(item, 'NumberOfPack', item.NumberOfPack)">
                            <div>{{ item.NumberOfPack || 0 }}</div>
                            <template v-slot:input>
                                <v-text-field
                                    v-model="item.NumberOfPack"
                                    label="Số kiện"
                                    type="number"
                                    single-line
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </template>

                    <!-- Số lượng -->
                    <template slot="item.ProductNumber" slot-scope="{ item }">
                        <v-edit-dialog
                            :return-value.sync="item.ProductNumber"
                            large
                            @save="saveField(item, 'ProductNumber', item.ProductNumber)">
                            <div>{{ item.ProductNumber || 0 }}</div>
                            <template v-slot:input>
                                <v-text-field
                                    v-model="item.ProductNumber"
                                    label="Số lượng"
                                    type="number"
                                    single-line
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </template>

                    <!-- Đơn giá USD -->
                    <template slot="item.CustomsPriceUSD" slot-scope="{ item }">
                        <v-edit-dialog
                            :return-value.sync="item.CustomsPriceUSD"
                            large
                            @save="saveField(item, 'CustomsPriceUSD', item.CustomsPriceUSD)">
                            <div>{{ item.CustomsPriceUSD || 0 }}</div>
                            <template v-slot:input>
                                <v-text-field
                                    v-model="item.CustomsPriceUSD"
                                    label="Đơn giá USD"
                                    type="number"
                                    step="0.001"
                                    single-line
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </template>

                    <!-- Đơn vị tính (vi) -->
                    <template slot="item.CustomsUnit" slot-scope="{ item }">
                        <v-edit-dialog
                            :return-value.sync="item.CustomsUnit"
                            large
                            @save="saveField(item, 'CustomsUnit', item.CustomsUnit)">
                            <div>{{ item.CustomsUnit || '-' }}</div>
                            <template v-slot:input>
                                <v-select
                                    v-model="item.CustomsUnit"
                                    :items="unitListVI"
                                    label="Đơn vị tính (vi)"
                                    single-line
                                ></v-select>
                            </template>
                        </v-edit-dialog>
                    </template>

                    <!-- Đơn vị tính (en) -->
                    <template slot="item.CustomsUnitEN" slot-scope="{ item }">
                        <v-edit-dialog
                            :return-value.sync="item.CustomsUnitEN"
                            large
                            @save="saveField(item, 'CustomsUnitEN', item.CustomsUnitEN)">
                            <div>{{ item.CustomsUnitEN || '-' }}</div>
                            <template v-slot:input>
                                <v-select
                                    v-model="item.CustomsUnitEN"
                                    :items="unitListEN"
                                    label="Đơn vị tính (en)"
                                    single-line
                                ></v-select>
                            </template>
                        </v-edit-dialog>
                    </template>

                    <!-- Trạng thái hàng -->
                    <template slot="item.ProdStatus" slot-scope="{ item }">
                        <div :style="{'color': display_color(item.ProdStatus, product_status_list)}">{{ item.ProdStatus | display_value(product_status_list) }}</div>
                    </template>

                    <!-- Thao tác -->
                    <template slot="item.action" slot-scope="{ item }">
                        <div class="d-flex align-center justify-center" style="height: 100%;">
                            <table-action-buttons :actions="getQuoteActions(item)"></table-action-buttons>
                        </div>
                    </template>
                </v-data-table>

                <v-dialog v-model="printLabelDialog" max-width="400px">
                  <v-card>
                    <v-card-title class="headline">In nhãn khai báo</v-card-title>
                    <v-card-text>
                      <v-text-field v-model="labelDialogData.LabelCode" label="Mã nhãn (LabelCode)" dense outlined></v-text-field>
                      <v-text-field v-model="labelDialogData.LabelDate" label="Ngày nhãn (LabelDate)" dense outlined></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="grey" text @click="printLabelDialog = false">Hủy</v-btn>
                      <v-btn color="primary" @click="confirmPrintLabel">Lưu & In</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <!-- Description Edit Dialog -->
                <v-dialog v-model="descriptionDialog" max-width="600px">
                  <v-card>
                    <v-card-title class="headline">Chỉnh sửa mô tả sản phẩm</v-card-title>
                    <v-card-text>
                      <v-text-field v-model="descriptionDialogData.BrandName" label="Nhãn hiệu" dense outlined></v-text-field>
                      <v-text-field v-model="descriptionDialogData.ProductMaterial" label="Chất liệu" dense outlined></v-text-field>
                      <v-text-field v-model="descriptionDialogData.ProductCapacity" label="Công suất" dense outlined></v-text-field>
                      <v-text-field v-model="descriptionDialogData.ProductSize" label="Kích thước" dense outlined></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="grey" text @click="descriptionDialog = false">Hủy</v-btn>
                      <v-btn color="primary" @click="saveDescription">Lưu</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <!-- Image Upload Dialog -->
                <v-dialog v-model="imageUploadDialog" max-width="500px">
                  <v-card>
                    <v-card-title class="headline">Tải ảnh sản phẩm</v-card-title>
                    <v-card-text>
                      <v-file-input
                        v-model="imageFile"
                        label="Chọn ảnh"
                        accept="image/*"
                        prepend-icon="mdi-camera"
                        outlined
                        dense
                        show-size
                        @change="previewImage"
                      ></v-file-input>
                      <v-img
                        v-if="imagePreview"
                        :src="imagePreview"
                        max-height="300"
                        contain
                        class="mt-3"
                      ></v-img>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="grey" text @click="closeImageUpload">Hủy</v-btn>
                      <v-btn 
                        color="primary" 
                        @click="uploadImage"
                        :loading="uploadingImage"
                        :disabled="!imageFile"
                      >
                        Tải lên
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <!-- Image View Dialog -->
                <v-dialog v-model="imageViewDialog" max-width="800px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Xem ảnh</span>
                      <v-spacer></v-spacer>
                      <v-btn icon @click="imageViewDialog = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text>
                      <v-img
                        v-if="viewingImageUrl"
                        :src="viewingImageUrl"
                        contain
                      ></v-img>
                    </v-card-text>
                  </v-card>
                </v-dialog>
            </v-card>
        </v-flex>
    </v-layout>
    <upload-file :dialogUpload="dialogImport" title="Import khai báo" @closePopup="dialogImport=false" @importFile="importFile"></upload-file>
    <v-overlay :value="loading" z-index="999999">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import { print_quote, print_quote_label } from "@/commons/hpod";
import { sendSuccessNotice, sendErrorNotice } from "@/commons/utils";
import upload_file from "@/components/popups/upload_file";
import Filtering from "@/components/Filtering";
import {display_color} from "@/commons/formater"
import firebase from 'firebase';
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering,
        "upload-file": upload_file,
    },
    data() {
        return {
            viewName: "quote_list",
            dialogImport: false,
            selectedItems: [],
            image_proxy: configs.IMAGE_PROXY,
            headers: [
                {
                    text: this.$t('table_headers.id'),
                    value: "ID",
                    filterable: true,
                    width: "100px",
                    dataType: configs.DATA_TYPE["Number"],
                    class: "fixed-column-1",
                    cellClass: "fixed-column-1"
                },
                {
                    text: this.$t('table_headers.customer_code'),
                    value: "Username",
                    filterable: true,
                    width: "160px",
                    dataType: configs.DATA_TYPE["String"],
                    class: "fixed-column-2",
                    cellClass: "fixed-column-2"
                },
                {
                    text: this.$t('table_headers.partner_product_code'),
                    value: "PartnerName",
                    filterable: true,
                    quickSearch: true,
                    width: "170px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.invoice_product_name'),
                    value: "ProductInfo",
                    filterable: true,
                    quickSearch: true,
                    width: "170px",
                    dataType: configs.DATA_TYPE["String"],
                },
                {
                    text: 'HSCODE',
                    value: "HsCode",
                    quickSearch: true,
                    filterable: true,
                    width: "100px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.commercial_name'),
                    value: "ProductNameVN",
                    filterable: true,
                    width: "160px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.product_description'),
                    value: "Description",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"],
                    sortable: false,
                    width: "200px"
                },
                {
                    text: this.$t('table_headers.product_image'),
                    value: "ImageUrl",
                    filterable: false,
                    sortable: false,
                    width: "100px"
                },
                // {
                //     text: 'Thuế NK (%)',
                //     value: "ImportTax",
                //     filterable: true,
                //     align: "right",
                //     width: "120px",
                //     dataType: configs.DATA_TYPE["Number"]
                // },
                {
                    text: this.$t('table_headers.invoice_price'),
                    value: "InvoicePrice",
                    filterable: true,
                    align: "right",
                    width: "130px",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.currency'),
                    value: "Currency",
                    filterable: true,
                    width: "130px",
                    dataType: configs.DATA_TYPE["String"]
                },
                // {
                //     text: 'Giá khai báo',
                //     value: "CustomsPriceVND",
                //     filterable: true,
                //     align: "right",
                //     width: "120px",
                //     dataType: configs.DATA_TYPE["Number"]
                // },
                // {
                //     text: 'Thuế VAT (%)',
                //     value: "VatTax",
                //     filterable: true,
                //     align: "right",
                //     width: "120px",
                //     dataType: configs.DATA_TYPE["Number"]
                // },
                // {
                //     text: 'Phí DV (%)',
                //     value: "ServiceFee",
                //     filterable: true,
                //     align: "right",
                //     width: "100px",
                //     dataType: configs.DATA_TYPE["Number"]
                // },
                // {
                //     text: 'Số kiện',
                //     value: "NumberOfPack",
                //     filterable: true,
                //     align: "right",
                //     width: "90px",
                //     dataType: configs.DATA_TYPE["Number"]
                // },
                {
                    text: this.$t('table_headers.quantity'),
                    value: "ProductNumber",
                    filterable: true,
                    align: "right",
                    width: "120px",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: 'Đơn giá USD',
                    value: "CustomsPriceUSD",
                    filterable: true,
                    align: "right",
                    width: "130px",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.product_unit_vi'),
                    value: "CustomsUnit",
                    filterable: true,
                    width: "160px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.product_unit_en'),
                    value: "CustomsUnitEN",
                    filterable: true,
                    width: "160px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.load_truck'),
                    value: "LicensePlate",
                    filterable: true,
                    quickSearch: true,
                    width: "100px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.product_status_header'),
                    value: "ProdStatus",
                    filterable: true,
                    width: "180px",
                    values: configs.PRODUCT_STATUS_LIST,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: this.$t('table_headers.action'),
                    value: "action",
                    width: "100px",
                    sortable: false,
                    filterable: false
                }
            ],
            pagination: {...configs.PAGINATION},
            items_per_page: {...configs.ITEMS_PER_PAGE},
            product_status_list: configs.PRODUCT_STATUS_LIST,
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
            printLabelDialog: false,
            labelDialogData: {
                LabelCode: '',
                LabelDate: ''
            },
            labelDialogItem: null,
            descriptionDialog: false,
            descriptionDialogData: {
                BrandName: '',
                ProductMaterial: '',
                ProductCapacity: '',
                ProductSize: ''
            },
            descriptionDialogItem: null,
            imageUploadDialog: false,
            imageFile: null,
            imagePreview: null,
            uploadingImage: false,
            uploadingItem: null,
            imageViewDialog: false,
            viewingImageUrl: null,
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                this.filter_data();
            },
            deep: true
        }
    },
    computed: {
        ...mapState({
            items: state => state.quote.all.data,
            total_rows: state => state.quote.all.total,
            loading: state => state.quote.loading,
            currentItem: state => state.quote.selected,
            customers: state => state.customer.master.data,
        }),
        adminRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin;
        },
        selectedTotalAmount() {
            return this.selectedItems.reduce((sum, item) => {
                return sum + (parseFloat(item.TotalAmount) || 0);
            }, 0);
        },
        unitListVI() {
            const config = this.$store.state.configuration ? this.$store.state.configuration.selected : null;
            const str = config && config.UnitListVI ? config.UnitListVI : '';
            if (!str) return [];
            return str.split(',').map(s => s.trim()).filter(Boolean);
        },
        unitListEN() {
            const config = this.$store.state.configuration ? this.$store.state.configuration.selected : null;
            const str = config && config.UnitListEN ? config.UnitListEN : '';
            if (!str) return [];
            return str.split(',').map(s => s.trim()).filter(Boolean);
        }
    },
    methods: {
        display_color,
        getQuoteActions(item) {
            return [
                { label: this.$t('actions.view'), variant: 'primary', onClick: () => this.openItem(item.ID) },
                { label: this.$t('actions.print_label'), variant: 'info', onClick: () => this.showPrintLabelDialog(item) },
                { label: this.$t('actions.print'), variant: 'info', onClick: () => this.printItem(item) },
                { label: this.$t('actions.duplicate'), variant: 'neutral', onClick: () => this.duplicateItem(item) },
                { label: this.$t('actions.delete'), variant: 'danger-outline', onClick: () => this.deleteItem(item.ID) }
            ];
        },
        deleteSelectedQuotes() {
            if (this.selectedItems.length === 0) {
                sendErrorNotice('Vui lòng chọn khai báo để xóa!');
                return;
            }
            if (!confirm(`Bạn có chắc chắn muốn xóa ${this.selectedItems.length} khai báo đã chọn?`)) {
                return;
            }
            const ids = this.selectedItems.map(item => item.ID);
            this.$store.dispatch("quote/removeBatch", ids)
                .then(() => {
                    sendSuccessNotice(`Đã xóa ${ids.length} khai báo thành công!`);
                    this.clearSelection();
                    this.filter_data();
                })
                .catch(() => {
                    sendErrorNotice('Có lỗi khi xóa khai báo!');
                });
        },
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("quote/getList", param);
            this.getCustomerList();
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        newItem: function () {
            this.$store.commit("quote/setDetail", { 'ID': 0 });
            let route = this.$router.resolve({
                name: 'QuoteDetail',
                params: { Pid: 'new', title: `Báo giá mới` }
            });
            window.open(route.href, '_blank');
        },
        openItem: function (id) {
            let route = this.$router.resolve({
                name: 'QuoteDetail',
                params: { Pid: id, title: `Chi tiết khai báo (#${id})` }
            });
            window.open(route.href, '_blank');
        },
        deleteItem: function(id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        selectAll() {
            this.selectedItems = [...this.items];
        },
        clearSelection() {
            this.selectedItems = [];
        },
        exportData(ignore_selection = 0) {
            // Kiểm tra xem có dòng nào được chọn không
            if (this.selectedItems.length === 0 && !ignore_selection) {
                sendErrorNotice('Vui lòng chọn ít nhất một khai báo để xuất file!');
                return;
            }
            const selectedIds = this.selectedItems.map(item => item.ID);
            var param = {
                filter: this.filterConditions.concat(this.quickFilterConditions),
                selectedIds: selectedIds // Thêm tham số selectedIds
            };
            this.$store.dispatch("quote/exportList", param)
                .then(() => {
                    sendSuccessNotice(`Đã xuất ${this.selectedItems.length} khai báo ra file Excel thành công!`);
                    this.clearSelection();
                })
                .catch(error => {
                    sendErrorNotice('Có lỗi xảy ra khi xuất file Excel. Vui lòng thử lại!');
                });
        },
        getStatusColor(status) {
            switch(status) {
                case 1: return 'orange';
                case 2: return 'green';
                case 3: return 'red';
                default: return 'grey';
            }
        },
        getStatusText(status) {
            switch(status) {
                case 1: return 'Chờ duyệt';
                case 2: return 'Đã duyệt';
                case 3: return 'Từ chối';
                default: return 'Nháp';
            }
        },
        formatCurrency(value) {
            if (!value) return '0';
            return new Intl.NumberFormat('vi-VN').format(value);
        },
        formatDate(date) {
            if (!date) return '';
            return new Date(date).toLocaleDateString('vi-VN');
        },
        printItem(item) {
            // Get item details before printing
            this.$store.dispatch("quote/getDetail", item.ID)
                .then(() => {
                    print_quote(this.currentItem, this.currentItem.Packages || []);
                });  
        },
        duplicateItem(item) {
            // Sao chép khai báo thành một khai báo mới với trạng thái chưa khai báo
            if (!confirm(`Bạn có chắc chắn muốn sao chép khai báo #${item.ID}?`)) {
                return;
            }
            
            // Lấy chi tiết khai báo gốc
            this.$store.dispatch("quote/getDetail", item.ID)
                .then(() => {
                    // Tạo object khai báo mới từ khai báo hiện tại
                    const newQuote = {
                        ...this.currentItem,
                        ID: 0, // ID = 0 để tạo mới
                        IsQuoted: false, // Đặt trạng thái chưa khai báo
                        Status: 0, // Trạng thái nháp
                        IsLinked: false, // Không liên kết với đơn hàng nào
                    };
                    
                    // Lưu khai báo mới
                    this.$store.dispatch("quote/setDetail", { data: newQuote, id: 0 })
                        .then((response) => {
                            sendSuccessNotice('Sao chép khai báo thành công!');
                            this.filter_data(); // Refresh danh sách
                            
                            // Mở tab chi tiết khai báo mới
                            if (response && response.data && response.data.ID) {
                                let route = this.$router.resolve({
                                    name: 'QuoteDetail',
                                    params: { Pid: response.data.ID, title: `Chi tiết khai báo (#${response.data.ID})` }
                                });
                                window.open(route.href, '_blank');
                            }
                        })
                        .catch(() => {
                            sendErrorNotice('Có lỗi xảy ra khi sao chép khai báo!');
                        });
                })
                .catch(() => {
                    sendErrorNotice('Không thể lấy thông tin khai báo để sao chép!');
                });
        },
        showPrintLabelDialog(item) {
            // Hiển thị dialog nhập thông tin nhãn
            this.labelDialogItem = item;
            this.labelDialogData.LabelCode = item.LabelCode || '';
            this.labelDialogData.LabelDate = item.LabelDate || '';
            this.printLabelDialog = true;
        },
        async confirmPrintLabel() {
            if (!this.labelDialogItem) return;
            // Lưu lại thông tin vào quote
            try {
                await this.$store.dispatch("quote/setDetail", {
                    data: {
                        LabelCode: this.labelDialogData.LabelCode,
                        LabelDate: this.labelDialogData.LabelDate
                    },
                    id: this.labelDialogItem.ID
                });
                // Cập nhật lại item để truyền vào hàm in
                this.labelDialogItem.LabelCode = this.labelDialogData.LabelCode;
                this.labelDialogItem.LabelDate = this.labelDialogData.LabelDate;
                this.printLabel(this.labelDialogItem);
                this.printLabelDialog = false;
            } catch (error) {
                sendErrorNotice('Lỗi khi lưu thông tin nhãn!');
            }
        },
        printLabel(item) {
            print_quote_label(item);
        },
        importFileDialog() {
            this.dialogImport = true;
        },
        importFile(filelist) {
            for(const f of filelist) {
                const formData = new FormData();
                formData.append('excel_file', f);
                formData.append('filename', f.name);
                this.$store.dispatch("quote/import_data", formData);
            }
            this.dialogImport = false;
        },
        getCustomerList() {
            this.$store.dispatch("customer/getCustomerList", {
                is_master: 1,
                fields: ["ID", "Username"]
            });
        },
        saveField(item, field, value) {
            let updateData = { [field]: value };
            // Nếu field là UID, cần cập nhật Username tương ứng
            if (field === 'UID') {
                const customer = this.customers.find(c => c.ID === value);
                if (customer) {
                    updateData.Username = customer.Username;
                    // Cập nhật ngay trên item để hiển thị
                    item.Username = customer.Username;
                } else {
                    updateData.Username = '';
                    item.Username = '';
                }
            }
            this.$store.dispatch("quote/setDetail", {
                data: updateData,
                id: item.ID
            }).then(() => {
                sendSuccessNotice('Đã cập nhật thành công!');
            }).catch(() => {
                sendErrorNotice('Có lỗi khi cập nhật!');
            });
        },
        editDescription(item) {
            this.descriptionDialogItem = item;
            this.descriptionDialogData.BrandName = item.BrandName || '';
            this.descriptionDialogData.ProductMaterial = item.ProductMaterial || '';
            this.descriptionDialogData.ProductCapacity = item.ProductCapacity || '';
            this.descriptionDialogData.ProductSize = item.ProductSize || '';
            this.descriptionDialog = true;
        },
        saveDescription() {
            if (!this.descriptionDialogItem) return;
            const updateData = {
                BrandName: this.descriptionDialogData.BrandName,
                ProductMaterial: this.descriptionDialogData.ProductMaterial,
                ProductCapacity: this.descriptionDialogData.ProductCapacity,
                ProductSize: this.descriptionDialogData.ProductSize
            };
            this.$store.dispatch("quote/setDetail", {
                data: updateData,
                id: this.descriptionDialogItem.ID
            }).then(() => {
                // Cập nhật lại item trong danh sách
                this.descriptionDialogItem.BrandName = this.descriptionDialogData.BrandName;
                this.descriptionDialogItem.ProductMaterial = this.descriptionDialogData.ProductMaterial;
                this.descriptionDialogItem.ProductCapacity = this.descriptionDialogData.ProductCapacity;
                this.descriptionDialogItem.ProductSize = this.descriptionDialogData.ProductSize;
                sendSuccessNotice('Đã cập nhật mô tả sản phẩm!');
                this.descriptionDialog = false;
            }).catch(() => {
                sendErrorNotice('Có lỗi khi cập nhật mô tả!');
            });
        },
        openImageUpload(item) {
            this.uploadingItem = item;
            this.imageUploadDialog = true;
        },
        closeImageUpload() {
            this.imageUploadDialog = false;
            this.imageFile = null;
            this.imagePreview = null;
            this.uploadingItem = null;
        },
        previewImage(file) {
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imagePreview = e.target.result;
                };
                reader.readAsDataURL(file);
            } else {
                this.imagePreview = null;
            }
        },
        async uploadImage() {
            if (!this.imageFile || !this.uploadingItem) return;

            // Validate file using fileUploadService
            const fileUploadService = require('@/services/fileUploadService').default;
            const validation = fileUploadService.validateFile(this.imageFile, ['jpg', 'jpeg', 'png', 'gif', 'webp'], 5);
            if (!validation.valid) {
                sendErrorNotice(validation.message);
                this.imageFile = null;
                return;
            }

            this.uploadingImage = true;
            try {
                const result = await fileUploadService.uploadSingleFile(this.imageFile, 'quote');
                if (result.success && result.data && result.data.url) {
                    const downloadURL = result.data.url;
                    this.uploadingItem.ImageUrl = downloadURL;
                    // Nếu có ID thì lưu vào DB
                    if (this.uploadingItem.ID) {
                        await this.$store.dispatch("quote/setDetail", {
                            data: { ImageUrl: downloadURL },
                            id: this.uploadingItem.ID
                        });
                    }
                    sendSuccessNotice('Upload ảnh thành công!');
                    this.closeImageUpload();
                } else {
                    sendErrorNotice(result.message || 'Lỗi upload ảnh!');
                }
            } catch (error) {
                console.error('Upload error:', error);
                sendErrorNotice('Lỗi upload ảnh!');
            } finally {
                this.uploadingImage = false;
            }
        },
        viewImage(imageUrl) {
            this.viewingImageUrl = imageUrl;
            this.imageViewDialog = true;
        },
    },
    mounted() {
        this.$store.dispatch("configuration/getDetail", 1);
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_CREATE_DATA", this.newItem);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("quote/removeDetail", id);
        });
        this.$root.$on("REQUEST_IMPORT_ACTION", this.importFileDialog);
        this.$root.$on("REQUEST_EXPORT_ACTION", () => {this.exportData(1)});
        
        // Load initial data
        this.selectedItems = [];
        this.filter_data();
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA", this.newItem);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
        this.$root.$off("REQUEST_IMPORT_ACTION");
        this.$root.$off("REQUEST_EXPORT_ACTION");
    }
};
</script>

<style scoped>
.v-chip {
    margin: 2px;
}

.selected-info {
    background-color: #f5f5f5;
    border-radius: 8px;
    padding: 8px 16px;
}

.export-button {
    background: linear-gradient(45deg, #4CAF50, #45a049);
    color: white;
}

.export-button:hover {
    background: linear-gradient(45deg, #45a049, #4CAF50);
}

.description-cell {
    font-size: 11px;
    line-height: 1.3;
}

.description-cell div {
    margin-bottom: 2px;
}

.cursor-pointer {
    cursor: pointer;
}
</style>

<style>
/* Fixed columns styles - Must be non-scoped to affect v-data-table */
.fixed-columns-table .v-data-table__wrapper {
    overflow-x: auto;
    overflow-y: auto;
}

/* Fixed header when scrolling vertically */
.fixed-columns-table thead th {
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
    background-color: #0051a2 !important;
}

/* Checkbox column - Column 1 */
.fixed-columns-table thead tr th:first-child {
    position: sticky !important;
    left: 0 !important;
    top: 0 !important;
    z-index: 11 !important;
    background-color: #0051a2 !important;
    border-right: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.fixed-columns-table tbody tr td:first-child {
    position: sticky !important;
    left: 0 !important;
    z-index: 3 !important;
    background-color: #fff !important;
    border-right: 1px solid #e0e0e0 !important;
}

/* Mã KH column - Column 2 */

.fixed-columns-table thead tr th.fixed-column-1 {
    position: sticky !important;
    left: 48px !important;
    top: 0 !important;
    z-index: 10 !important;
    background-color: #0051a2 !important;
    border-right: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.fixed-columns-table tbody tr td:nth-child(2) {
    position: sticky !important;
    left: 48px !important;
    z-index: 2 !important;
    background-color: #fff !important;
    border-right: 1px solid #e0e0e0 !important;
}

/* Tên loại hàng column - Column 3 */

.fixed-columns-table thead tr th.fixed-column-2 {
    position: sticky !important;
    left: 148px !important;
    top: 0 !important;
    z-index: 10 !important;
    background-color: #0051a2 !important;
    box-shadow: 2px 0 5px rgba(0,0,0,0.15) !important;
}

.fixed-columns-table tbody tr td:nth-child(3) {
    position: sticky !important;
    left: 148px !important;
    z-index: 2 !important;
    background-color: #fff !important;
    box-shadow: 2px 0 5px rgba(0,0,0,0.08) !important;
}

/* Hover effect for body rows */
.fixed-columns-table tbody tr:hover td:first-child,
.fixed-columns-table tbody tr:hover td:nth-child(2),
.fixed-columns-table tbody tr:hover td:nth-child(3) {
    background-color: #f5f5f5 !important;
}

/* Remove default table borders for cleaner look */
.fixed-columns-table .v-data-table__wrapper table {
    border-collapse: separate;
    border-spacing: 0;
}
</style>
